<template>
<p>Loading...</p>
</template>

<script>

import axios from 'axios'
import { BaseURL } from '../../shared/classes'
import router from '../../router/index'
export default {
  name: 'screenit-card',
  data () {
    return {
      BaseURL: BaseURL,
      mainurl: '/getAuthDetails'
    }
  },
  created () {
    this.getDatas()
  },
  methods: {
    getDatas () {
      const data = {
        formData: {
          user_email: this.$route.params.id,
          type_of_account: 'organization'
        }
      }
      axios.post(`${this.BaseURL}${this.mainurl}`, data).then(response => {
        console.log(response)
        localStorage.setItem('user__details', JSON.stringify(response.data.userdetail))
        localStorage.setItem('token', JSON.stringify(response.data.token))
        router.push({ name: 'Dashboard' })
      }).catch(e => {
        console.log(e)
      })
    }
  }
}
</script>
